








































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/model-left-nav.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav,
    Pagination
  }
})
export default class ModelTrain extends Vue {
  private info: any = {};
  private models: any[] = [];
  private projects: any[] = [];
  private tables: any[] = [];
  private versions: any[] = [];
  // 状态
  private cState: "doing" | "done" = "done";
  private trainHelpText: any = "";
  // 翻页
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  /**
   * @description 获取模型列表
   */
  private getModels() {
    axios.get("api/model/train/models").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.models = data.data;
      });
    });
  }
  /**
   * @description 获取项目列表
   */
  private getProjects() {
    axios.get("api/model/train/projects").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.projects = data.data;
      });
    });
  }
  /**
   * @description 开始训练
   */
  private startTrain() {
    if (!this.info.model_id || !this.info.project_id) {
      this.$message.warning("请完整选择训练条件");
      return;
    }
    const params: any = this.info;
    axios.post("api/model/train", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.currentPage = 1;
        this.getVersions();
      });
    });
  }
  /**
   * @description 获取项目列表
   */
  private getTables() {
    axios.get("api/model/train/tables").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.tables = data.data;
      });
    });
  }
  /**
   * @description 获取版本列表
   */
  private getVersions() {
    const params: any = {
      params: {
        model_id: this.info.model_id,
        current_page: this.currentPage,
        page_count: this.pageSize
      }
    };
    axios.get("api/model/versions", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.versions = data.data.versions;
        this.totalCount = data.data.total_count;
        this.totalPage = data.data.total_page;
        if (data.data.can_train === false) {
          this.trainHelpText = data.data["训练状态"];
          this.cState = "doing";
        } else {
          this.cState = "done";
        }
      });
    });
  }
  /**
   * 切换当前模型
   */
  private changeModel(val) {
    this.info.model_id = val;
    this.currentPage = 1;
    this.getVersions();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.getVersions();
  }
  /**
   * @description 跳转报告
   */
  private goToReport(version) {
    const { href } = this.$router.resolve({
      path:
        "/main/model/model-report/" +
        version.model_id +
        "/" +
        version.version_id
    });
    window.open(href, "_blank");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getModels();
    this.getProjects();
    this.getTables();
    if (this.$route.params["model_id"]) {
      this.info.model_id = this.$route.params.model_id;
      this.getVersions();
    }
  }
}
